import { ProductLineId } from './lib/catalog';

export interface FlavorOption {
  /** Catalog id (`line:slug`) for Wonderful flavors, `emoji:<name>` for additional ones. */
  id: string;
  name: string;
  /** Absolute path or URL of the flavor art. */
  image?: string;
  emoji?: string;
  /** A draft product in Shopify: prints with a Coming Soon tag. */
  comingSoon?: boolean;
}

export interface CategoryData {
  /** Stable React key for the section's editor (see sectionUid). */
  uid?: string;
  line: ProductLineId;
  /** Banner text printed above the flavors. */
  name: string;
  /** Banner color. */
  color: string;
  flavors: FlavorOption[];
  /** Leave the Coming Soon tag off this section's flavors (default: shown). */
  hideComingSoon?: boolean;
}

export const MAX_SECTIONS = 3;
export const BANNER_COLORS = ['#55B6E7', '#7ECAE6', '#F48FB1'];

export interface MenuData {
  officeName: string;
  menuTitle: string;
  logo?: File;
  categories: CategoryData[];
  fontSize: {
    officeName: number;
    title: number;
    categoryTitle: number;
    flavorName: number;
  };
  confetti: {
    enabled: boolean;
    density: number;
    size: number;
    shape: 'stars' | 'dots' | 'hearts';
    colors: string[];
  };
  font: string;
  flavorImageSize: number;
  /** Size the flavor art to fill the page; flavorImageSize is used when off. */
  autoFit?: boolean;
  flavorSpacing: number; // Gap between flavors in pixels
  logoSize: number; // max dimension (px)
  bannerStyle?: 'classic' | 'angled' | 'bubble' | 'wavy';
  /** Optional line printed at the bottom of the page. */
  footerNote?: string;
}

// Extra flavors an office can add by name; they print as emoji instead of mascot art.
const emoji = (name: string, symbol: string): FlavorOption => ({ id: `emoji:${name.toLowerCase()}`, name, emoji: symbol });

export const EMOJI_FLAVORS: FlavorOption[] = [
  emoji('Apple', '🍎'),
  emoji('Apricot', '🍑'),
  emoji('Banana', '🍌'),
  emoji('Berry Mix', '🫐'),
  emoji('Birthday Cake', '🎂'),
  emoji('Candy', '🍬'),
  emoji('Cherry', '🍒'),
  emoji('Chocolate', '🍫'),
  emoji('Cinnamon Roll', '🥮'),
  emoji('Coconut', '🥥'),
  emoji('Coffee', '☕'),
  emoji('Cookie', '🍪'),
  emoji('Cotton Candy', '🍭'),
  emoji('Cupcake', '🧁'),
  emoji('Grape', '🍇'),
  emoji('Green Apple', '🍏'),
  emoji('Honey', '🍯'),
  emoji('Ice Cream', '🍦'),
  emoji('Kiwi', '🥝'),
  emoji('Lemon', '🍋'),
  emoji('Mango', '🥭'),
  emoji('Maple', '🍁'),
  emoji('Orange', '🍊'),
  emoji('Pear', '🍐'),
  emoji('Pineapple', '🍍'),
  emoji('Strawberry', '🍓'),
  emoji('Watermelon', '🍉')
];
